const Connect = () => null;
export default Connect;
